import { Droppable, Draggable } from "react-beautiful-dnd";
import { Music } from "../types/global.type";
import StateContext from "../StateContext";
import { useContext } from "react";
import { RequestFactory } from "../libs/services";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { serverUrl } from "../App";

const grid = 8;

const getItemStyle = (isDragging: any, draggableStyle: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : "grey",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const handleSetMusic = async (newId: string) => {
  RequestFactory.currentMusic.change(newId);
};

const handleDeleteMusic = async (
  musicId: string,
  playlistId: number | undefined
) => {
  if (!playlistId) return;
  await axios.post(`${serverUrl}/api/music/delete`, {
    playlistId,
    musicId,
  });
};

const DndMenu = () => {
  const context = useContext(StateContext);

  return (
    <Droppable droppableId="droppable">
      {(provided) => (
        <div
          className="list-music-container"
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          {context.currentPlaylist?.musics.map((item, index) => (
            <Draggable key={item.id} draggableId={item.id} index={index}>
              {(provided) => (
                <div
                  className="music-item-container"
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                >
                  <div
                    {...provided.dragHandleProps}
                    style={{
                      height: "30px",
                      width: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingLeft: "20px",
                    }}
                  >
                    <div
                      className={
                        "numMusic" +
                        (item.id === context.currentMusic?.id
                          ? " current-music"
                          : "")
                      }
                    >
                      {index + 1}
                    </div>
                    <div className="dragIcon">
                      <DragIndicatorIcon
                        sx={{
                          color:
                            item.id === context.currentMusic?.id
                              ? "#04d361"
                              : "",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className={
                      "title-item-music" +
                      (item.id === context.currentMusic?.id
                        ? " current-music"
                        : "")
                    }
                    onClick={() => handleSetMusic(item.id)}
                  >
                    {item.title}
                  </div>
                  <div
                    className={
                      "thumbail-item-music " +
                      (item.id === context.currentMusic?.id
                        ? " current-music-thumbail"
                        : "")
                    }
                  >
                    <img src={item.thumbail} alt="thumbail" />
                  </div>
                  <div
                    className="delete-item-music"
                    onClick={() =>
                      handleDeleteMusic(item.id, context.currentPlaylist?.id)
                    }
                  >
                    <DeleteIcon />
                  </div>
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default DndMenu;
